import { Card, Space, Row, Col, Typography, Divider } from "antd";
import UserLink from "~/components/user/UserLink";
import GroupProfile from "~/components/groups/GroupProfile";
import GroupJoin from "~/components/groups/GroupJoin";
import GroupDescription from "~/components/groups/GroupDescription";

const { Text } = Typography;

/**
 * 群组信息卡片，用于群组详情页面
 * 
 * @param {object} group 群组信息
 */
const GroupViewCard = ({ group }) => {
  return (
    <Card>
      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
        <GroupProfile group={group} />
        <GroupDescription group={group} />
        <GroupJoin group={group} />
        <Divider style={{ margin: 0 }} />
        <Row justify="space-between">
          <Col><Text>群主</Text></Col>
          <Col><UserLink user={group.user} showAvatar /></Col>
        </Row>
      </Space>
    </Card>
  );
};

export default GroupViewCard;
